<template>
 <div class="container-fluid bg-dark h-100">
    <router-view></router-view>
  </div>
</template>

<script>


export default {

  data() {
    return{
    }   
  },

  mounted(){
  },



  methods: {}
};
</script>
<style lang="scss" scoped>

</style>
